export default __webpack_public_path__ + "static/media/identity-scanning.dfff439e.jpg";